/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Symptom from './symptom';
import SymptomDetail from './symptom-detail';
import SymptomUpdate from './symptom-update';
import SymptomDeleteDialog from './symptom-delete-dialog';

const SymptomRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Symptom />} />
    <Route path="new" element={<SymptomUpdate />} />
    <Route path=":id">
      <Route index element={<SymptomDetail />} />
      <Route path="edit" element={<SymptomUpdate />} />
      <Route path="delete" element={<SymptomDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SymptomRoutes;
